import { string } from "prop-types";
import { SideContainer, WidgetContainer } from "../UI/Containers";
import Divider from "../UI/Divider";
import AutoPlans from "./AutoPlans";
import Dates from "./Dates";
import Marketing from "./Marketing";
import { tdpDetails } from "../../shared/HOCs/withRedux";
import { TYPE } from "../../shared/reduxRoutes/tdpDetailsRoutes";
import { useAccountProducts, useFeatureFlags, useIsAdmin } from "../../reducers/layoutReducer/selectors";
import { isReferral } from "../shared/helpers";
import TitleAndEscrow from "./TitleAndEscrow";
import ConnectServices from "./ConnectServices";
import DisableAutomatedSendModal from "../shared/DisableAutomatedSendModal";
import EnableAutomatedSendModal from "../shared/EnableAutomatedSendModal";

const ReferralSideRight = () => (
  <SideContainer>
    <div className="tw-block">
      <WidgetContainer>
        <Dates />
      </WidgetContainer>
      <Divider />
      <WidgetContainer>
        <AutoPlans />
      </WidgetContainer>
    </div>
  </SideContainer>
);

const NonReferralSideRight = ({ type }) => {
  const featureFlags = useFeatureFlags();
  const accountProducts = useAccountProducts();
  // Only admins can activate Connect Services, so everyone else sees the widget once the account
  // already has it.
  const isAdmin = Boolean(useIsAdmin());
  const showConnectServices = accountProducts.connectService || isAdmin;
  return (
    <SideContainer>
      <DisableAutomatedSendModal />
      <EnableAutomatedSendModal />
      <div className="tw-block">
        <WidgetContainer>
          <Dates />
        </WidgetContainer>
        <Divider />
        {featureFlags.blueprintTitle && (type === "buyer" || type === "seller") && (
          <>
            <WidgetContainer>
              <TitleAndEscrow />
            </WidgetContainer>
            <Divider />
          </>
        )}
        <WidgetContainer>
          <AutoPlans />
        </WidgetContainer>
        <Divider />
        {showConnectServices && (
          <>
            <WidgetContainer>
              <ConnectServices />
            </WidgetContainer>
            <Divider />
          </>
        )}
        <WidgetContainer>
          <Marketing />
        </WidgetContainer>
      </div>
    </SideContainer>
  );
};

const SideRight = ({ type }) =>
  !isReferral(type) ? <NonReferralSideRight type={type} /> : <ReferralSideRight />;

SideRight.propTypes = {
  type: string,
};

SideRight.defaultProps = {
  type: null,
};
export default tdpDetails({ WrappedComponent: SideRight, states: TYPE });
